/* <wg-rail>: horizontal scroll rail with previous/next controls.
   No autoplay. Controls hide automatically when there is no overflow. */
(function () {
  if (customElements.get('wg-rail')) return;

  class WGRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.wg-rail__track');
      this.controls = this.querySelector('.wg-rail__controls');
      this.prevBtn = this.querySelector('[data-wg-rail-prev]');
      this.nextBtn = this.querySelector('[data-wg-rail-next]');
      if (!this.track) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByPage(1));

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.scrollRaf) return;
      this.scrollRaf = requestAnimationFrame(() => {
        this.scrollRaf = null;
        this.update();
      });
    }

    scrollByPage(direction) {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollBy({ left: this.track.clientWidth * 0.85 * direction, behavior: behavior });
    }

    update() {
      const overflow = this.track.scrollWidth - this.track.clientWidth;
      if (this.controls) this.controls.hidden = overflow < 8;
      if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', this.track.scrollLeft <= 4);
      if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', this.track.scrollLeft >= overflow - 4);
    }
  }

  customElements.define('wg-rail', WGRail);
})();
